import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgNotificationBell = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#0C6A93"
            d="M7.997 16c-.341 0-.682-.08-.985-.232a1.92 1.92 0 0 1-.99-1.127c-.085-.265.081-.543.37-.621a.6.6 0 0 1 .153-.02c.24 0 .455.147.523.359a.9.9 0 0 0 .467.532 1.04 1.04 0 0 0 .739.072.93.93 0 0 0 .658-.604.54.54 0 0 1 .523-.359q.078 0 .153.02c.288.078.455.356.37.62-.199.621-.721 1.1-1.398 1.283Q8.294 16 7.997 16"
        />
        <path
            stroke="#0C6A93"
            d="M7.997 16c-.341 0-.682-.08-.985-.232a1.92 1.92 0 0 1-.99-1.127c-.085-.265.081-.543.37-.621a.6.6 0 0 1 .153-.02c.24 0 .455.147.523.359a.9.9 0 0 0 .467.532 1.04 1.04 0 0 0 .739.072.93.93 0 0 0 .658-.604.54.54 0 0 1 .523-.359q.078 0 .153.02c.288.078.455.356.37.62-.199.621-.721 1.1-1.398 1.283Q8.294 16 7.997 16Z"
        />
        <path
            fill="#0C6A93"
            d="M1.545 12.72c.084.17.26.28.45.28h12a.504.504 0 0 0 .339-.867c-.009-.009-.84-.931-.84-5.133a5.49 5.49 0 0 0-5-5.477V.5a.5.5 0 0 0-1 0v1.023a5.49 5.49 0 0 0-5 5.477c0 3.878-.88 5.172-.893 5.192a.5.5 0 0 0-.056.527"
        />
        <path
            stroke="#0C6A93"
            d="M1.545 12.72c.084.17.26.28.45.28h12a.504.504 0 0 0 .339-.867c-.009-.009-.84-.931-.84-5.133a5.49 5.49 0 0 0-5-5.477V.5a.5.5 0 0 0-1 0v1.023a5.49 5.49 0 0 0-5 5.477c0 3.878-.88 5.172-.893 5.192a.5.5 0 0 0-.056.527Z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgNotificationBell)
const Memo = memo(ForwardRef)
export default Memo
